import classNames from 'classnames'
import { FormikProps } from 'formik'
import { deepCopy } from '../../helpers'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import { Button } from '../button'
import { ActionChip } from '../cards/actionChip'
import Icon from '../icon'
import { TextInput } from '../inputs/textInput'

export const ManageProductKeywords = ({
  formik,
  className,
}: {
  formik: FormikProps<CreateProductValues>
  className?: string
}) => {
  const { values, errors, setFieldValue, handleBlur, handleChange, touched } =
    formik

  return (
    <div className={classNames('flex flex-col gap-3', className)}>
      <p>Key words</p>

      <div className="flex items-center flex-wrap gap-6">
        {values.searchKeywords?.map((keyword, idx) => {
          return (
            <ActionChip
              key={`${keyword}-${idx}`}
              name={
                <p className="flex items-center gap-2.5">
                  <Icon
                    id="sparkle"
                    width={16}
                    height={16}
                    className="text-primary"
                  />
                  {keyword}
                </p>
              }
              icon={undefined}
              onDismiss={() => {
                const keywordsCopy = deepCopy(values.searchKeywords ?? [])
                setFieldValue(
                  'searchKeywords',
                  keywordsCopy.filter((i) => i !== keyword),
                )
              }}
            />
          )
        })}
      </div>

      <TextInput
        type="text"
        name="keywordTyped"
        placeholder="Enter keyword"
        value={values.keywordTyped}
        onBlur={handleBlur}
        onChange={handleChange}
        errors={
          errors.keywordTyped && touched.keywordTyped ? errors.keywordTyped : ''
        }
        hasIcon={false}
        className="max-w-[302px]"
      />

      <Button
        type="button"
        onClick={() => {
          const keywordsCopy = deepCopy(values.searchKeywords ?? [])
          setFieldValue('searchKeywords', [
            ...keywordsCopy,
            values.keywordTyped,
          ])
          setFieldValue('keywordTyped', '')
        }}
        label="Save"
        primary
        className="w-fit"
        disabled={!values.keywordTyped}
      />
    </div>
  )
}
